// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agents-app {
  padding: 10px 14px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/agents-widget/agents-widget.component.scss"],"names":[],"mappings":"AAAA;EAAc,kBAAA;EAAoB,cAAA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,SAAA;AAMzF","sourcesContent":[".agents-app { padding: 10px 14px; overflow: auto; display: flex; flex-direction: column; gap: 14px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
